import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

/**
 * Globaler Error Handler für insertBefore-Fehler
 * 
 * Diese Fehler treten auf Mobile Chrome auf und können durch
 * einen einfachen Reload behoben werden. Wir fangen sie hier
 * global ab um einen Crash zu verhindern.
 */
const handleGlobalError = (event) => {
  const error = event.error || event.reason;
  const message = error?.message || String(error) || '';
  
  // insertBefore/removeChild Fehler erkennen
  if (message.includes('insertBefore') || 
      message.includes('removeChild') || 
      message.includes('NotFoundError')) {
    
    console.warn('[GlobalErrorHandler] DOM error detected:', message);
    
    // Fehler-Event unterdrücken
    event.preventDefault?.();
    event.stopPropagation?.();
    
    // NICHT sofort reloaden - das würde zu einer Reload-Schleife führen
    // Stattdessen: Nur beim ERSTEN Auftreten in dieser Session reloaden
    const recoveryKey = 'dom_error_recovery_' + window.location.pathname;
    const lastRecovery = sessionStorage.getItem(recoveryKey);
    const now = Date.now();
    
    // Nur reloaden wenn letzter Recovery-Versuch > 10 Sekunden her ist
    if (!lastRecovery || (now - parseInt(lastRecovery)) > 10000) {
      sessionStorage.setItem(recoveryKey, now.toString());
      
      // Verzögerter Reload
      setTimeout(() => {
        window.location.reload();
      }, 100);
    }
    
    return true;
  }
  
  return false;
};

// Event Listener registrieren
window.addEventListener('error', handleGlobalError);
window.addEventListener('unhandledrejection', handleGlobalError);

/**
 * WICHTIG: React.StrictMode wurde ENTFERNT!
 * 
 * React.StrictMode verursacht doppeltes Rendering, was auf Mobile-Geräten
 * zu insertBefore DOM-Fehlern führen kann, besonders in Kombination mit
 * Portal-basierten Komponenten wie Sonner Toaster.
 */
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
